import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type IconPencilProps = IconComponentBaseProps;

export const IconPencil = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: IconPencilProps) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill={fill} fillRule="evenodd">
        <path
          d="M1.613 10.753c-.267.059-.443-.113-.394-.38l.33-1.816c.049-.268.251-.329.442-.144l1.554 1.5c.195.189.136.389-.129.447l-1.803.393zM8.875.49c.189-.196.504-.197.695-.013l1.554 1.5c.195.19.192.51.011.696l-6.41 6.64c-.19.195-.505.196-.696.012l-1.554-1.5c-.195-.189-.192-.509-.011-.696L8.874.49z"
          transform="translate(-1)"
        />
      </g>
    </svg>
  );
};
